import React, { useState } from 'react'
import "./Gallery2.css"
import items from "./Images"





function Gallery2() {

    const [image, setimage] = useState(items)

    return (
        <>
           
            <div class="container-fluid" style={{marginTop:"6%"}}>
                <div class="row">
                    <div class="col-md-12">
                        <div class="gal">

                            {image.map((element) => {
                                return <img src={element.image} alt="" />




                            })}
                        </div>
                    </div>
                </div>
            </div>






        </>
    )
}

export default Gallery2
